import React from 'react';
import { useRaceStore } from '../../stores/raceStore';
import { useTranslation } from '../../utils/i18n';
import { Card, CardContent } from '../ui/Card';
import { ActivityIcon, ZapIcon, TrendingUpIcon, ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
import { SafePenaltyIntensity } from '../../types';
export function ExecutionScenariosSection() {
  const {
    t
  } = useTranslation();
  const {
    settings,
    updateSettings
  } = useRaceStore();
  return <div className="bg-white rounded-2xl border border-[#E8E8ED] shadow-sm overflow-hidden" data-id="element-1031">
      <div className="px-5 py-3.5 border-b border-[#E8E8ED]" data-id="element-1032">
        <div className="flex items-center gap-2.5" data-id="element-1033">
          <ActivityIcon className="h-5 w-5 text-[#FC4C02]" data-id="element-1034" />
          <span className="text-base font-bold text-[#2D2D2D]" data-id="element-1035">
            {t('scenarios.title')}
          </span>
        </div>
      </div>

      <div className="p-5 space-y-4" data-id="element-1036">
        <p className="text-sm text-[#6B6B76]" data-id="element-1037">{t('scenarios.desc')}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1038">
          <button onClick={() => updateSettings({
          executionScenario: 'optimal'
        })} className={`p-4 rounded-xl border text-left transition-all ${settings.executionScenario === 'optimal' ? 'bg-[#F0F9FF] border-[#0666EB] ring-1 ring-[#0666EB]' : 'bg-[#F7F7FA] border-[#E8E8ED] hover:bg-white'}`} data-id="element-1039">
            <div className="flex items-center gap-2 mb-2" data-id="element-1040">
              <ZapIcon className="h-4 w-4 text-[#0666EB]" data-id="element-1041" />
              <span className="font-bold text-[#2D2D2D]" data-id="element-1042">
                {t('scenarios.optimal')}
              </span>
            </div>
            <p className="text-xs text-[#6B6B76]" data-id="element-1043">
              {t('scenarios.optimalDesc')}
            </p>
          </button>

          <button onClick={() => updateSettings({
          executionScenario: 'standard'
        })} className={`p-4 rounded-xl border text-left transition-all ${settings.executionScenario === 'standard' ? 'bg-[#ECFDF5] border-[#00B843] ring-1 ring-[#00B843]' : 'bg-[#F7F7FA] border-[#E8E8ED] hover:bg-white'}`} data-id="element-1044">
            <div className="flex items-center gap-2 mb-2" data-id="element-1045">
              <TrendingUpIcon className="h-4 w-4 text-[#00B843]" data-id="element-1046" />
              <span className="font-bold text-[#2D2D2D]" data-id="element-1047">
                {t('scenarios.standard')}
              </span>
            </div>
            <p className="text-xs text-[#6B6B76]" data-id="element-1048">
              {t('scenarios.standardDesc')}
            </p>
          </button>

          <button onClick={() => updateSettings({
          executionScenario: 'safe'
        })} className={`p-4 rounded-xl border text-left transition-all ${settings.executionScenario === 'safe' ? 'bg-[#FFFBEB] border-[#FF9500] ring-1 ring-[#FF9500]' : 'bg-[#F7F7FA] border-[#E8E8ED] hover:bg-white'}`} data-id="element-1049">
            <div className="flex items-center gap-2 mb-2" data-id="element-1050">
              <ShieldCheckIcon className="h-4 w-4 text-[#FF9500]" data-id="element-1051" />
              <span className="font-bold text-[#2D2D2D]" data-id="element-1052">
                {t('scenarios.safe')}
              </span>
            </div>
            <p className="text-xs text-[#6B6B76]" data-id="element-1053">{t('scenarios.safeDesc')}</p>
          </button>
        </div>

        {settings.executionScenario === 'safe' && <div className="pt-4 border-t border-[#F0F0F5]" data-id="element-1054">
            <div className="flex items-center justify-between" data-id="element-1055">
              <div data-id="element-1056">
                <h4 className="text-sm font-bold text-[#2D2D2D]" data-id="element-1057">
                  {t('settings.safeIntensity')}
                </h4>
                <p className="text-xs text-[#9B9BA7] mt-0.5" data-id="element-1058">
                  {t('settings.safeIntensityDesc')}
                </p>
              </div>
              <div className="flex items-center bg-[#F7F7FA] p-1 rounded-lg border border-[#E8E8ED]" data-id="element-1059">
                {(['low', 'default', 'high'] as SafePenaltyIntensity[]).map(intensity => <button key={intensity} onClick={() => updateSettings({
              safePenaltyIntensity: intensity
            })} className={`
                      px-3 py-1.5 rounded-md text-xs font-bold transition-all
                      ${settings.safePenaltyIntensity === intensity ? 'bg-white text-[#2D2D2D] shadow-sm border border-[#E8E8ED]' : 'text-[#9B9BA7] hover:text-[#6B6B76]'}
                      `} data-id="element-1060">
                      {t(`intensity.${intensity}`)}
                    </button>)}
              </div>
            </div>
          </div>}

        <div className="flex items-start gap-2 p-3 bg-[#F0F9FF] border border-[#BAE6FD] rounded-xl" data-id="element-1061">
          <AlertTriangleIcon className="h-4 w-4 text-[#0284C7] mt-0.5" data-id="element-1062" />
          <div className="text-xs text-[#0C4A6E]" data-id="element-1063">
            <strong data-id="element-1064">{t('scenarios.climateNote').split(':')[0]}:</strong>{' '}
            {t('scenarios.climateNote').split(':').slice(1).join(':')}
          </div>
        </div>
      </div>
    </div>;
}